export default {
      id: "sorting-usage",
      viewBox: "0 0 8 12",
      url: __webpack_public_path__ + "svg/sprite.svg#sorting",
      toString: function () {
        return this.url;
      }
    }